import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CuadroDatos from '../../UI/CuadroDatos.js';
import { NombreEquipoTorneo } from '../../funciones/FuncionesEquipo.js';
import * as Paises from '../../constantes/Paises.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './CuadroTorneosPais.module.css';

const CuadroTorneosPais = (props) => {
  const pais = props.pais;
  const titulo = props.titulo;
  const [listaTorneos, setListaTorneos] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idPais = pais && pais.id;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idPais) {
      let torneoURL = 'paises/' + idPais + '/ultimos_campeones?limiteAnios=2';
      if (idPais !== Paises.ARGENTINA) {
        torneoURL += '&limiteNivel=2&incluirCopas=true';
      }
      fetchData(torneoURL, setListaTorneos);
    } else {
      setListaTorneos([]);
    }
  }, [idPais, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={titulo ? titulo : pais.nombre}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        {listaTorneos && listaTorneos.length > 0 && (
          <table className={`${styles.tablaCampeones}`}>
            <tbody>
              <tr className={`${styles.titulos}`}>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.campeon}`}>Campeón</td>
              </tr>
              {listaTorneos.map((torneo, index) => (
                <tr key={index} className={`${styles.filaTorneo}`}>
                  <td className={`${styles.torneo}`} data-label="Torneo">
                    <Link to={'/torneos/' + torneo.id}>{torneo.descripcion}</Link>
                  </td>
                  <td className={`${styles.campeon}`} data-label="Campeón">
                    <div className={styles.valorCelda}>
                      {Array.isArray(torneo.campeones)
                        ? torneo.campeones.map((equipo, index_) => (
                            <div key={index_} className={styles.valorItem}>
                              {NombreEquipoTorneo(equipo, torneo)}
                            </div>
                          ))
                        : NombreEquipoTorneo(torneo.campeones, torneo)}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CuadroDatos>
    </div>
  );
};

export default CuadroTorneosPais;
